// ==================== MODERN COLOR PALETTE ====================

export const colors = {
  // Primary gradients - Purple to Blue
  primary: {
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    main: '#667eea',
    light: '#8a9ff0',
    dark: '#5a6fd8',
    contrastText: '#ffffff',
  },

  // Secondary gradients - Pink to Red
  secondary: {
    gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    main: '#f093fb',
    light: '#f3a6fc',
    dark: '#e67ff8',
    contrastText: '#ffffff',
  },

  // Success gradients - Blue to Cyan
  success: {
    gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    main: '#4facfe',
    light: '#6fb7fe',
    dark: '#3d8bfe',
    contrastText: '#ffffff',
  },

  // Warning gradients - Orange gradients
  warning: {
    gradient: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
    main: '#ff9f43',
    light: '#ffb366',
    dark: '#ff8c1a',
    contrastText: '#ffffff',
  },

  // Error gradients - Pink gradients
  error: {
    gradient: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
    main: '#ff6b6b',
    light: '#ff8a8a',
    dark: '#ff5252',
    contrastText: '#ffffff',
  },

  // Info gradients - Light blue
  info: {
    gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
    main: '#54a0ff',
    light: '#74b9ff',
    dark: '#3c7eff',
    contrastText: '#ffffff',
  },

  // Neutral colors
  grey: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },

  // Background gradients
  background: {
    default: '#fafafa',
    paper: '#ffffff',
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    lightGradient: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    darkGradient: 'linear-gradient(135deg, #232526 0%, #414345 100%)',
  },

  // Glass effects
  glass: {
    light: 'rgba(255, 255, 255, 0.25)',
    dark: 'rgba(0, 0, 0, 0.25)',
    border: 'rgba(255, 255, 255, 0.18)',
    darkBorder: 'rgba(255, 255, 255, 0.1)',
  },

  // Shadow colors
  shadows: {
    primary: 'rgba(102, 126, 234, 0.4)',
    secondary: 'rgba(240, 147, 251, 0.4)',
    success: 'rgba(79, 172, 254, 0.4)',
    warning: 'rgba(255, 159, 67, 0.4)',
    error: 'rgba(255, 107, 107, 0.4)',
    neutral: 'rgba(0, 0, 0, 0.1)',
  },
};
